import React, { useEffect, useState } from "react";
import { MainContainer } from "./styles";
import CustomButton from "../../general/CustomButton";
import Steps from "./Steps";
import CustomTemplate from "./CustomTemplate";
import UploadTemplate from "./UploadTemplate";
import PreviewData from "./PreviewData";
import { fetchCategories, getUserData } from "./utils";

const BulkLoading = () => {
  const isRetailer = JSON.parse(sessionStorage.getItem("user")).is_retailer === 1;
  const [lists, setLists] = useState({
    depot: [],
  });
  const [article, setArticle] = useState({
    depot: "",
    category: "",
    type: "",
    retailer: isRetailer ? "" : [],
  });
  useEffect(() => {
    const loadInitialData = async () => {
      const providers = await getUserData("isProviders=1");
      setLists((prev) => ({
        ...prev,
        providers: providers.map((e) => ({
          value: e.id_company,
          name: e.trade_name,
        })),
      }));

      const company = JSON.parse(sessionStorage.getItem("company"));
      const key = company.financedRetailers ? "financedRetailers" : "retailers";
      const query =
        isRetailer || key === "financedRetailers"
          ? `?id=${encodeURIComponent(
              company[key].map((ret) => ret.id).join(",")
            )}`
          : "";

      const categories = await fetchCategories(query);

      setLists((prev) => ({
        ...prev,
        depot: categories,
      }));
    };

    loadInitialData();
  }, [isRetailer]);
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep < 2) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevStep) => prevStep - 1);
    }
  };

  return (
    <MainContainer>
      <div className="step-container">
        <Steps activeStep={activeStep} />
        <div className="step-content">
          {activeStep === 0 && (
            <CustomTemplate
              lists={lists}
              article={article}
              setArticle={setArticle}
            />
          )}
          {activeStep === 1 && <UploadTemplate />}
          {activeStep === 2 && <PreviewData />}
        </div>
        <div className="buttons">
        <CustomButton
          variant="gray"
          onClick={handleBack}
          disabled={activeStep === 0}
          icon="chevron_left"
          tooltipText="Ir al paso anterior"
          showTooltip
          iconOnly
        />
        <CustomButton
          variant="gray"
          onClick={handleNext}
          disabled={activeStep === 2}
          icon="chevron_right"
          tooltipText="Ir al siguiente paso "
          showTooltip
          iconOnly
        />
      </div>
      </div>
    </MainContainer>
  );
};

export default BulkLoading;